import { ChevronRightIcon } from '@heroicons/react/24/outline';
import { Link } from 'react-router-dom';

import { FractionState, NeedsApprovalShift } from '../api/types';
import { formatShiftDateTime } from '../util/dateFormat';

// One needs-approval row (per shift/job): Date & time · Client · Skill ·
// Location · a fraction column whose label + colour vary by sub-state, and a
// chevron that drills into the shift/job detail (Shift Detail panel).
//
// Sub-state labels + colours (colours added per AC — the Figma mock rendered
// all three identically): Hired = green, For Hired = yellow, For approval = blue.
const FRACTION_LABEL: Record<FractionState, string> = {
  hired: 'Hired',
  for_hired: 'For Hired',
  for_approval: 'For approval',
};

type Props = { shift: NeedsApprovalShift };

const NeedsApprovalRow = ({ shift }: Props) => {
  const tz = shift.timezone;
  const to = shift.order_id
    ? `/orders/${shift.order_id}/jobs/${shift.job_id}`
    : '#';

  const col = (label: string, value: string, modifier: string) => (
    <div className={`dashv2-nscol dashv2-nacol--${modifier}`}>
      <p className="dashv2-nslabel">{label}</p>
      <p className="dashv2-nsvalue" title={value}>
        {value || '—'}
      </p>
    </div>
  );

  return (
    <div className="dashv2-nscard">
      <div className="dashv2-narow">
        {col(
          'Date & time',
          formatShiftDateTime(shift.start_at, shift.end_at, tz),
          'date',
        )}
        {col('Client', shift.client_name || '', 'client')}
        {col('Skill', shift.skill_name || '', 'skill')}
        {col('Location', shift.location_code || '', 'loc')}
        <div className="dashv2-nscol dashv2-nacol--fraction">
          <p className="dashv2-nslabel">
            {FRACTION_LABEL[shift.fraction_state]}
          </p>
          <p className={`dashv2-nafraction-val state-${shift.fraction_state}`}>
            {shift.hired_count}/{shift.quantity}
          </p>
        </div>
        <Link
          className="dashv2-nsexpand"
          to={to}
          aria-label="Open shift detail"
        >
          <ChevronRightIcon />
        </Link>
      </div>
    </div>
  );
};

export default NeedsApprovalRow;
